export default "__VITE_ASSET__ScaMCOyR__"